import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Fab from "@material-ui/core/Fab";

//icons
import RefreshIcon from "@material-ui/icons/Refresh";

//components

import AdminWrapper from "../../containers/AdminWrapper";
import ContentWrapper from "../../containers/ContentWrapper";

//Services
import shotService from "../../services/shotService";
import { CircularProgress } from "@material-ui/core";

export default class ViewOnePackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      failed: false,
      fetched: false,
      orderBy: "scene",
      order: "asc",
      filterstate: "",
      data: [],
      scenes: []
    };
  }

  componentDidMount() {
    this.getOnePackage();
  }

  getOnePackage = async () => {
    try {
      if (!this.state.fetching) this.setState({ fetching: true });
      let { data } = await shotService.getOnePackage(this.props.match.params.id);
      // console.log("dataonepack", data);
      let scenes = data.shots
        .map(i => i.scene)
        .filter((item, i, arr) => arr.indexOf(item) === i)
        .sort();
      this.setState({ data, fetching: false, fetched: true, failed: false, scenes, filterstate: "" });
    } catch (err) {
      // console.log(err);
      this.setState({ data: [], scenes: [], fetching: false, failed: true });
    }
  };
  handleEditShots = () => this.props.history.push(`/packages/${this.props.match.params.id}/shots/edit`);

  handleAddShots = () => this.props.history.push(`/packages/${this.props.match.params.id}/shots/add`);

  createSortHandler = property => {
    // console.log("sort", property);
    this.handleRequestSort(property);
  };
  handleRequestSort = property => {
    const isDesc = this.state.orderBy === property && this.state.order === "desc";
    this.setState({ order: isDesc ? "asc" : "desc" });
    this.setState({ orderBy: property });
  };

  stableSort = (array, cmp) => {
    // console.log("data", array);
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };

  getSorting = (order, orderBy) => {
    return order === "desc" ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
  };

  desc = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  handleChangeFilter = e => {
    this.setState({
      filterstate: e.target.value
    });
  };

  render() {
    const { orderBy, order, data, filterstate, fetching, fetched, failed } = this.state;

    if (fetching && !fetched)
      return (
        <AdminWrapper {...this.props}>
          <ContentWrapper hasHeader title="View Package" hasPadding={true}>
            <div style={{ paddingTop: 20, textAlign: "center" }}>
              <CircularProgress />
            </div>
          </ContentWrapper>
        </AdminWrapper>
      );
    else if (failed)
      return (
        <AdminWrapper {...this.props}>
          <ContentWrapper hasHeader title="View Package" hasPadding={true}>
            <div style={{ paddingTop: 20, textAlign: "center" }}></div>
            <div style={{ padding: "20px 0", textAlign: "center" }}>
              <Typography variant="h3" gutterBottom style={{ color: "rgba(0,0,0,0.5)" }}>
                Something went wrong...
              </Typography>
              <Button variant="outlined" color="primary" onClick={this.getOnePackage}>
                Reload
              </Button>
            </div>
          </ContentWrapper>
        </AdminWrapper>
      );

    // console.log("datarender", data);

    let queryData = this.stableSort(data.shots, this.getSorting(order, orderBy));
    let photoLists =
      data.shots != undefined &&
      queryData
        .filter(e => e.scene.includes(filterstate))
        .map((row, index) => (
          <TableRow key={row.id} hover>
            <TableCell>{row.scene}</TableCell>
            <TableCell>{row.description}</TableCell>
            <TableCell>{row.location}</TableCell>
            <TableCell>{row.angle}</TableCell>
            <TableCell>{row.framing}</TableCell>
            {row.type === "video" && <TableCell>{row.camera}</TableCell>}
          </TableRow>
        ));
    // console.log(photoLists);
    const headCells = [
      { id: "scene", numeric: false, disablePadding: false, label: "Scene", width: "15%" },
      { id: "description", numeric: false, disablePadding: false, label: "Description", width: this.state.data.type === "photo" ? "30%" : "15%" },
      { id: "location", numeric: false, disablePadding: false, label: "Location", width: "15%" },
      { id: "angle", numeric: false, disablePadding: false, label: "Angle", width: "15%" },
      { id: "framing", numeric: false, disablePadding: false, label: "Framing", width: "15%" }
    ];

    if (this.props.type == "video") {
      headCells.push({ id: "camera", numeric: false, disablePadding: false, label: "Camera", width: "15%" });
    }
    // console.log("sample", this.props.type);
    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="View Package" hasPadding={true}>
          <Paper>
            <Grid container>
              <Grid item xs={12} sm={12}>
                {this.props.fetching ? (
                  <div style={{ textAlign: "center" }}>
                    <LinearProgress color="primary" style={{ height: 2 }} />
                  </div>
                ) : this.props.failed ? (
                  <div>
                    <h1>Failed to load. Please try again later.</h1>
                    <Button size="small" variant="contained" color="secondary" onClick={this.getShots} style={{ marginLeft: 20 }}>
                      Reload
                    </Button>
                  </div>
                ) : null}
                <Toolbar>
                  <div style={{ margin: "20px 0" }}>
                    <Typography variant="h5" gutterBottom>
                      {data.title}
                    </Typography>
                    <Typography variant="subtitle2">{data.description}</Typography>
                  </div>
                  <div style={{ flexGrow: 1 }} />
                  {data.id !== "82ccc656-bae6-4e0d-97ca-7b0a63ff4e6f" && data.id !== "678336f4-231c-4181-947a-95655434e06c" && (
                    <>
                      <Button variant="outlined" color="primary" onClick={this.handleAddShots} style={{ marginRight: 5 }}>
                        Add Shots
                      </Button>
                      <Button variant="outlined" color="primary" onClick={this.handleEditShots} style={{ marginLeft: 5 }}>
                        Remove Shots
                      </Button>
                    </>
                  )}
                </Toolbar>
                <Divider />

                <Toolbar variant="dense" style={{ padding: "10px 15px 20px", margin: "auto" }} disableGutters={true}>
                  <Typography variant="body2" color="textSecondary">
                    Total Records: <b>{this.state.data.shots.length}</b>
                  </Typography>
                  <div style={{ flexGrow: 1 }} />
                  <Typography variant="body2" style={{ marginRight: 8 }} color="textSecondary">
                    Filter Scene:
                  </Typography>
                  <FormControl variant="outlined" style={{ marginRight: 10 }}>
                    <Select
                      value={this.state.filterstate}
                      onChange={this.handleChangeFilter}
                      displayEmpty={true}
                      input={<OutlinedInput name="filter" margin="dense" placeholder="Filter" labelWidth={0} />}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {this.state.scenes.map(i => (
                        <MenuItem value={i} key={i}>
                          {i}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Divider style={{ margin: "0 10px", height: 40, width: 2 }} />
                  <div>
                    <Tooltip title="Refresh List">
                      <IconButton onClick={this.getOnePackage} aria-label="Refresh">
                        <RefreshIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </Toolbar>
                {fetching && fetched && <LinearProgress style={{ height: 2 }} />}
                <Table style={{ tableLayout: "fixed" }}>
                  {/* <TableHead>
                <TableRow>
                  <TableCell style={{ width: '10%'}} padding="checkbox"><Checkbox onClick={this.props.onSelectedAll} checked={this.props.selectedAll} /></TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '15%' : '10%' }}>Scene</TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '36%' : '35%' }}>Description</TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '13%' : '10%' }}>Location</TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '13%' : '10%' }}>Angle</TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '13%' : '10%' }}>Framing</TableCell>
                  {
                    this.props.type === "video" 
                    ?
                    <TableCell style={{ width: '10%'}}>Camera Movement</TableCell>
                    : null
                  }
                </TableRow>
              </TableHead> */}
                  <TableHead>
                    <TableRow>
                      {headCells.map((row, key) => (
                        <TableCell
                          key={key}
                          align={row.numeric ? "right" : "left"}
                          padding={row.disablePadding ? "none" : "default"}
                          sortDirection={orderBy === row.id ? order : false}
                          onClick={row.id == "" ? null : () => this.createSortHandler(row.id)}
                          style={row.id == "" ? { width: row.width } : { cursor: "pointer", width: row.width }}
                        >
                          {this.state.orderBy === row.id ? (
                            <TableSortLabel active={orderBy === row.id} direction={order}>
                              {row.label}
                            </TableSortLabel>
                          ) : (
                            row.label
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>{photoLists}</TableBody>
                </Table>
              </Grid>
            </Grid>
          </Paper>
        </ContentWrapper>
      </AdminWrapper>
    );
  }
}
